import Wrapper from './Wrapper.vue';

const Machines = () => import('./_views/machines');
const MachineDrawersHistory = () => import('./_views/machineDrawersHistory');

const parentRouteConfig = {
  name: 'Machines',
  to: {
    name: 'machines',
    query: {
      suffix: '',
      pageNum: '1',
    },
  },
};

export default [
  {
    path: '/additional/machines',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'machines',
        component: Machines,
        meta: {
          title: 'Machines',
          group: 'additional',
          navigation: {
            position: 2,
            name: 'Machines',
            specialQueries: ['suffix'],
            to: {
              name: 'machines',
              query: {
                suffix: '',
              },
            },
          },
        },
      },
      {
        path: ':machine/drawer/:drawer',
        name: 'machineDrawerHistory',
        component: MachineDrawersHistory,
        meta: {
          title: 'Machine Drawers History',
          enableSetSuffix: true,
          parent: parentRouteConfig,
          customDisplayedParamKey: 'drawer',
        },
      },
    ],
  },
];
